import { useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { queryKeyContains } from '../utils/data-fetching-utils';

export const useClearPreviousOperationData = (operation: string): void => {
  const queryClient = useQueryClient();
  const previousOperation = useRef<string>(operation);

  useEffect(() => {
    if (operation && previousOperation.current !== operation) {
      queryClient.removeQueries({ predicate: q => queryKeyContains(q.queryKey, previousOperation.current) });
      previousOperation.current = operation;
    }
  }, [operation]);
};
